import PropTypes from 'prop-types'
import helpIcon from '../assets/icons/help-icon.svg'
import Tooltip from './Tooltip'

const HelpTooltip = ({ content }) => {
  const helpButton = (
    <img 
      src={helpIcon} 
      alt="Help" 
      className="w-3 h-3 ml-1 cursor-help opacity-60 hover:opacity-100 transition-opacity"
    />
  )

  const tooltipContent = (
    <div className="whitespace-pre-wrap leading-relaxed">
      {content}
    </div>
  )

  return (
    <Tooltip button={helpButton} content={tooltipContent} />
  )
}

HelpTooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
}

export default HelpTooltip 